import script from "./restricted.vue?vue&type=script&setup=true&lang=js"
export * from "./restricted.vue?vue&type=script&setup=true&lang=js"

import "./restricted.vue?vue&type=style&index=0&id=54bec51c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54bec51c"]])

export default __exports__